export const APP_VERSION_CODE = 10405;
export const APP_VERSION_NAME = "1.4.5";
